// Third-party dependencies
import '@hotwired/turbo-rails';
import '@rails/actiontext';
import 'trix';
import Alpine from 'alpinejs';

// Local components
import { initGlideCarousel } from './src/components/carousel';

// Import Alpine.js components
import './src/alpine';

// Alpine.js initialization
window.Alpine = Alpine;
Alpine.start();

// Initialize components when DOM is ready
document.addEventListener('turbo:load', () => {
  initGlideCarousel();
});

import * as ActiveStorage from '@rails/activestorage';

ActiveStorage.start();
